import React, { useEffect, useState } from "react";
import packageJson from "../../../../package.json";
import styled, { keyframes } from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router";
import * as Library from "../../../utils/Library";
import TermsAndPrivacyPanel from "../../common/termsandConditions/TermsAndPrivacyPanel";

import loginBackground from "../../../assets/images/login-redesign/background.jpg";
import botagLogo from "../../../assets/images/login-redesign/botag-logo.png";
import bostagerLogo from "../../../assets/images/login-redesign/bostager-logo.png";

// #region SCOPED CSS
const StyledPage = styled.main`
    position: relative;
    box-sizing: border-box;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    padding: 80px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.18)),
        #10141b url(${loginBackground}) center / cover no-repeat;
    color: #f5f5f5;
    font-family: Roboto, sans-serif;

    .botag-logo {
        position: absolute;
        top: max(24px, env(safe-area-inset-top));
        left: max(24px, env(safe-area-inset-left));
        width: 66px;
        max-width: calc(100% - 48px);
        height: auto;
    }

    .login-card,
    .login-card * {
        box-sizing: border-box;
    }

    .login-card {
        position: relative;
        width: 100%;
        max-width: 400px;
        min-width: 0;
        padding: 32px 32px 18px;
        border: 1px solid rgba(255, 255, 255, 0.35);
        border-radius: 20px;
        background: rgba(20, 22, 23, 0.94);
        box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);
    }

    @supports ((backdrop-filter: blur(8px)) or (-webkit-backdrop-filter: blur(8px))) {
        .login-card {
            background: rgba(20, 22, 23, 0.78);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
        }
    }

    .bostager-logo {
        display: block;
        width: 165px;
        max-width: 100%;
        height: auto;
        margin: 0 auto 8px;
    }

    .login-subtitle {
        color: #d1d1d1;
        font-size: 12px;
        line-height: 1.5;
    }

    .welcome-back {
        margin: 0 0 8px;
    }

    .login-subtitle {
        margin: 0 0 24px;
        text-align: center;
        text-transform: none;
    }

    .login-title {
        margin: 0 0 24px;
        font-size: 17px;
        font-weight: 400;
        line-height: 1.4;
    }

    .credentials {
        display: flex;
        flex-direction: column;
        gap: 18px;
        width: 100%;
        min-width: 0;
    }

    .input-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
        min-width: 0;
    }

    .input-label {
        margin: 0;
        color: #e2e2e2;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.5;
    }

    .login-input {
        width: 100%;
        min-width: 0;
        min-height: 44px;
        padding: 10px 12px;
        border: 1px solid #737778;
        border-radius: 6px;
        background: rgba(20, 22, 23, 0.3);
        color: #f5f5f5;
        font: inherit;
        font-size: 16px;
        line-height: 1.4;
    }

    .login-input[aria-invalid="true"] {
        border-color: #ffaaaa;
    }

    .password-field {
        position: relative;
    }

    .password-field .login-input {
        padding-right: 48px;
    }

    .login-card button {
        font-family: inherit;
        cursor: pointer;
    }

    .password-toggle {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 100%;
        min-height: 44px;
        padding: 0;
        border: 0;
        border-radius: 6px;
        background: transparent;
        color: #e2e2e2;
    }

    .forgot-password {
        align-self: flex-end;
        min-height: 32px;
        margin: -12px 0 0;
        padding: 4px 0;
        border: 0;
        background: transparent;
        color: #d4e0e5;
        font-size: 13px;
        text-decoration: underline;
    }

    .login-button {
        align-self: center;
        width: 75%;
        max-width: 235px;
        min-height: 44px;
        padding: 10px 16px;
        border: 1px solid #555555;
        border-radius: 6px;
        background: #090909;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.4;
    }

    .login-button:hover:not(:disabled) {
        background: #292929;
    }

    .login-button:active:not(:disabled) {
        background: #181818;
    }

    .login-card button:disabled {
        cursor: not-allowed;
    }

    .login-button:disabled {
        background: #252525;
        color: #b8b8b8;
        border-color: #4a4a4a;
    }

    .login-input:focus-visible,
    .login-card button:focus-visible {
        outline: 2px solid #7ee57e;
        outline-offset: 3px;
    }

    .login-terms {
        margin: 0;
        color: #dedede;
        font-size: 12px;
        line-height: 1.6;
        text-align: center;
        overflow-wrap: anywhere;
    }

    .login-terms button {
        margin: 0;
        padding: 3px 0;
        border: 0;
        background: transparent;
        color: inherit;
        font-size: inherit;
        text-decoration: underline;
    }

    .privacy-policy-link {
        white-space: nowrap;
    }

    .login-footer {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 6px 10px;
        margin-top: 20px;
        padding-top: 14px;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        color: #d1d1d1;
        font-size: 11px;
        line-height: 1.5;
        text-align: center;
    }

    .login-error {
        margin-bottom: 16px;
        padding: 12px;
        border: 1px solid rgba(255, 170, 170, 0.45);
        border-radius: 6px;
        background: rgba(95, 0, 0, 0.45);
        color: #ffbebe;
        font-size: 13px;
        line-height: 1.5;
        overflow-wrap: anywhere;
    }

    .loading-filters {
        opacity: 0.5;
        filter: blur(4px);
    }

    .DialogPregraf {
        width: 296px;
        font-size: 12px;
        align-items: center;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        margin-bottom: 16px;
        font-style: normal;
        line-height: normal;
    }

    .DialogLayout {
        margin-bottom: 28px;
    }

    .login-input:-webkit-autofill {
        -webkit-text-fill-color: #ffffff;
        box-shadow: inset 0 0 0 100px #202323;
    }


    @media (max-width: 400px) {
        .botag-logo {
            top: max(16px, env(safe-area-inset-top));
            left: max(16px, env(safe-area-inset-left));
        }

        .login-card {
            padding: 28px 20px 18px;
        }
    }
`;
const resetAmberSweep = keyframes`
    from { transform: translateX(-100%); }
    to { transform: translateX(300%); }
`;

const StyledResetLoader = styled.div`
    display: flex;
    justify-content: center;
    position: static;
    width: 100%;

    .child-container {
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
        width: 100%;
    }
    .blur-filter { filter: blur(2px); }
    .login-progress-status {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99997;
        width: 220px;
        max-width: calc(100% - 24px);
        text-align: center;
        pointer-events: none;
    }
    .login-progress-label {
        display: block;
        margin-bottom: 10px;
        color: #ead2ac;
        font-size: 11px;
        font-weight: 500;
        letter-spacing: 0.16em;
        line-height: 1.4;
    }
    .login-progress-track {
        display: block;
        position: relative;
        overflow: hidden;
        height: 6px;
        border: 1px solid rgba(222, 172, 94, 0.24);
        border-radius: 999px;
        background: rgba(23, 25, 26, 0.88);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.5), 0 0 10px rgba(216, 156, 62, 0.12);
    }
    .login-progress-sweep {
        display: block;
        width: 50%;
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(90deg, transparent, #c58c36 30%, #efbf73 65%, transparent);
        box-shadow: 0 0 6px rgba(239, 191, 115, 0.25);
        animation: ${resetAmberSweep} 1.8s ease-in-out infinite;
    }
    @media (prefers-reduced-motion: reduce) {
        .login-progress-sweep {
            animation: none;
            transform: translateX(50%);
        }
    }
`;

// #endregion

// #region RESET LOADER
function ResetProgressLoader({ isLoading, children }) {
    return (
        <StyledResetLoader>
            {isLoading && (
                <div className="login-progress-status" role="status" aria-live="polite" aria-atomic="true">
                    <span className="login-progress-label">UPDATING PASSWORD</span>
                    <span className="login-progress-track" aria-hidden="true">
                        <span className="login-progress-sweep" />
                    </span>
                </div>
            )}
            <div className={isLoading ? "child-container blur-filter" : "child-container"} aria-busy={isLoading}>
                {children}
            </div>
        </StyledResetLoader>
    );
}
// #endregion

export default function ResetPasswordPage(props) {
    document.title = `${APP_TITLE} - Reset Password`;
    const navigate = useNavigate();
    const location = useLocation();

    const query = new URLSearchParams(location.search);
    const token = query.get("token");

    /* #region STATES */

    const [newPassword, setNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [showTAC, setShowTAC] = useState({
        termsAndConditions: false,
        privacyPolicy: false
    });
    /* #endregion */

    /* #region METHODS */
    const handlePasswordsValidation = (pass1, pass2) => {
        //TODO: Check what validations are needed later
        const minLength = 8;
        const minSpecialChars = 0;
        const minNumbers = 0;
        const minUppercase = 0;
        const minLowercase = 0;

        const hasMinLength = pass1.length >= minLength;
        const passwordsMatch = pass1 === pass2;

        if (!hasMinLength) {
            setErrorMessage(`Password must be at least ${minLength} characters long.`);
            return false;
        }

        if (!passwordsMatch) {
            setErrorMessage("Passwords do not match.");
            return false;
        }

        const specialChars = /[^A-Za-z0-9]/g;
        const numbers = /[0-9]/g;
        const uppercase = /[A-Z]/g;
        const lowercase = /[a-z]/g;

        if ((pass1.match(specialChars) || []).length < minSpecialChars) {
            setErrorMessage(`Password must contain at least ${minSpecialChars} special character.`);
            return false;
        }

        if ((pass1.match(numbers) || []).length < minNumbers) {
            setErrorMessage(`Password must contain at least ${minNumbers} number.`);
            return false;
        }

        if ((pass1.match(uppercase) || []).length < minUppercase) {
            setErrorMessage(`Password must contain at least ${minUppercase} uppercase letter.`);
            return false;
        }

        if ((pass1.match(lowercase) || []).length < minLowercase) {
            setErrorMessage(`Password must contain at least ${minLowercase} lowercase letter.`);
            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (isLoading) return;
        if (handlePasswordsValidation(newPassword, confirmPassword)) {
            setErrorMessage("");
            setIsLoading(true);
            Library.makeCommonPostRequest(
                "Users",
                "updateUserPassword",
                { token, newPassword },
                false,
                setIsLoading
            ).then(res => {
                if (res.data?.status === 200) {
                    navigate("/login");
                    Library.showSuccessMessage(
                        "Your email is now reset. You can proceed with logging in to your account."
                    );
                }
            });
        }
    };

    const handleKeyPress = e => {
        if (e.key === "Enter") {
            handleSubmit(e);
        }
    };

    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        if (newPassword && confirmPassword) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [confirmPassword, newPassword]);

    useEffect(() => {
        if (token) {
            Library.makeCommonPostRequest("Users", "validateNewPasswordToken", { token }).then(res => {
                if (res.data.status !== 200) {
                    navigate("/login");
                }
            });
        } else {
            navigate("/login");
            Library.showErrorMessage("Invalid Reset Password Token.");
        }
    }, [token]);

    /* #endregion */

    /* #region COMPONENTS */
    const getEyeIcon = showPassword => {
        if (showPassword)
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M7.66196 3.39488C7.9329 3.35482 8.2124 3.33333 8.50028 3.33333C11.9036 3.33333 14.1369 6.33656 14.8871 7.52455C14.9779 7.66833 15.0233 7.74023 15.0488 7.85112C15.0678 7.93439 15.0678 8.06578 15.0487 8.14905C15.0233 8.25993 14.9776 8.3323 14.8861 8.47705C14.6862 8.79343 14.3814 9.23807 13.9777 9.7203M4.98288 4.47669C3.5415 5.45447 2.56297 6.81292 2.11407 7.52352C2.02286 7.66791 1.97725 7.74011 1.95183 7.85099C1.93273 7.93426 1.93272 8.06563 1.95181 8.14891C1.97722 8.25979 2.02262 8.33168 2.11342 8.47545C2.86369 9.66344 5.09694 12.6667 8.50028 12.6667C9.87255 12.6667 11.0546 12.1784 12.0259 11.5177M2.50028 2L14.5003 14M7.08606 6.58579C6.72413 6.94772 6.50028 7.44772 6.50028 8C6.50028 9.10457 7.39571 10 8.50028 10C9.05256 10 9.55256 9.77614 9.91449 9.41421"
                        stroke="#D1D1D1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        else
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M2.11342 8.47562C2.02262 8.33186 1.97723 8.25998 1.95182 8.14911C1.93273 8.06583 1.93273 7.9345 1.95182 7.85122C1.97723 7.74035 2.02262 7.66847 2.11341 7.52471C2.86369 6.33672 5.09693 3.3335 8.50027 3.3335C11.9036 3.3335 14.1369 6.33672 14.8871 7.52471C14.9779 7.66847 15.0233 7.74035 15.0487 7.85122C15.0678 7.9345 15.0678 8.06583 15.0487 8.14911C15.0233 8.25998 14.9779 8.33186 14.8871 8.47562C14.1369 9.6636 11.9036 12.6668 8.50027 12.6668C5.09693 12.6668 2.86369 9.6636 2.11342 8.47562Z"
                        stroke="#D1D1D1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.50027 10.0002C9.60484 10.0002 10.5003 9.10473 10.5003 8.00016C10.5003 6.89559 9.60484 6.00016 8.50027 6.00016C7.3957 6.00016 6.50027 6.89559 6.50027 8.00016C6.50027 9.10473 7.3957 10.0002 8.50027 10.0002Z"
                        stroke="#D1D1D1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    };

    /* #endregion */

    return (
        <StyledPage>
            {showTAC.termsAndConditions && (
                <TermsAndPrivacyPanel
                    type="terms"
                    onCloseClicked={() =>
                        setShowTAC({
                            termsAndConditions: false,
                            privacyPolicy: false
                        })
                    }
                />
            )}
            {showTAC.privacyPolicy && (
                <TermsAndPrivacyPanel
                    type="privacy"
                    onCloseClicked={() =>
                        setShowTAC({
                            termsAndConditions: false,
                            privacyPolicy: false
                        })
                    }
                />
            )}
            <img className="botag-logo" src={botagLogo} alt="BOtag" />
            <section className="login-card" aria-labelledby="reset-password-title">
                <img className="bostager-logo" src={bostagerLogo} alt="BOstageR" />
                <p className="login-subtitle">The BOtag platform for retailers</p>
                <h1 id="reset-password-title" className="login-title">RESET PASSWORD</h1>
                {errorMessage && <div className="login-error" role="alert">{errorMessage}</div>}
                <ResetProgressLoader isLoading={isLoading}>
                    <div className={"credentials " + (isLoading ? "loading-filters" : "")}>
                        <div className="input-field">
                            <label className="input-label" htmlFor="reset-new-password">New password</label>
                            <div className="password-field">
                                <input id="reset-new-password" className="login-input" type={showPassword ? "text" : "password"}
                                    autoComplete="new-password" value={newPassword}
                                    onChange={e => setNewPassword(e.target.value.trim())} onKeyUp={handleKeyPress} />
                                <button type="button" className="password-toggle" aria-controls="reset-new-password"
                                    aria-label={showPassword ? "Hide new password" : "Show new password"}
                                    aria-pressed={showPassword} onClick={() => setShowPassword(!showPassword)}>
                                    {getEyeIcon(showPassword)}
                                </button>
                            </div>
                        </div>
                        <div className="input-field">
                            <label className="input-label" htmlFor="reset-confirm-password">Repeat new password</label>
                            <div className="password-field">
                                <input id="reset-confirm-password" className="login-input" type={showConfirmPassword ? "text" : "password"}
                                    autoComplete="new-password" value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value.trim())} onKeyUp={handleKeyPress} />
                                <button type="button" className="password-toggle" aria-controls="reset-confirm-password"
                                    aria-label={showConfirmPassword ? "Hide repeat new password" : "Show repeat new password"}
                                    aria-pressed={showConfirmPassword} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                    {getEyeIcon(showConfirmPassword)}
                                </button>
                            </div>
                        </div>
                        <button type="button" className="login-button" disabled={isLoading || buttonDisable}
                            onClick={handleSubmit}>RESET</button>
                        <p className="login-terms">
                            By continuing you agree to BOtag{" "}
                            <button type="button" onClick={() => setShowTAC({ termsAndConditions: true, privacyPolicy: false })}>Terms</button>
                            {" "}and{" "}
                            <button type="button" className="privacy-policy-link"
                                onClick={() => setShowTAC({ termsAndConditions: false, privacyPolicy: true })}>Privacy Policy</button>.
                        </p>
                    </div>
                </ResetProgressLoader>
                <footer className="login-footer">
                    <span>BOtag Norge AS © {moment().format("yyyy")}</span>
                    <span>App Version {packageJson.version}</span>
                </footer>
            </section>
        </StyledPage>
    );
}
